import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('notesField');

    return {
        NOTES_FIELD_LABEL: t('notesFieldLabel')
    };
};

export default useTranslation;
